module.exports = __webpack_public_path__ + "media/images/patent/y_3-f121f84e716c3e8b5d7dd717a51af1d3.jpg";